// extracted by mini-css-extract-plugin
module.exports = {"root":"coming-events_root__V3CEe","content":"coming-events_content__XyZkH","navigation":"coming-events_navigation__qWslW","cards":"coming-events_cards__SX1PN"};